import { Routes, Route, Navigate } from "react-router-dom";

import { NavBarPublic } from "../../NavBar/NavBarPublic";
import { Home } from "../views/Home";
import { AboutUs } from "../AboutUs/AboutUs";
import {Advertisements} from "../views/Advertisements";
import { SaintPaulThelogicalnstitute } from "../Institutes/SaintPaulThelogicalnstitute";
import { MinisterialTrainingInstitute } from "../Institutes/MinisterialTrainingInstitute";
import {InstituteForPastoesAndChildrensMinisters} from "../Institutes/InstituteForPastoesAndChildrensMinisters.jsx"
import {MusicInsitute} from "../Institutes/MusicInsitute";
import { Blogs } from "../views/Blogs";
import {Contact} from "../views/Contact";
import Footer from "../../components/Footer";
import { Login } from "../../Auth/components/Login";


export const PublicClientRoutes = () => {
  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <NavBarPublic />
      
      {/* Contenedor principal que crece para empujar el footer hacia abajo */}
      <main className="flex-grow-1">
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="home" element={<Home />} />
          <Route path="aboutus" element={<AboutUs/>} />
          <Route path="advertisements" element={<Advertisements/>} />
          
          {/* Rutas de Institutos */}
          <Route path="institutes/saint_paul_theological_institute" element={<SaintPaulThelogicalnstitute />} />
          <Route path="institutes/ministerial_training_institute" element={<MinisterialTrainingInstitute/>} />
          <Route path="institutes/institute_for_pastoes_and_childrens_ministers" element={<InstituteForPastoesAndChildrensMinisters/>} />
          <Route path="institutes/music_insitute" element={<MusicInsitute/>} />
          
          <Route path="blogs" element={<Blogs/>} />
          <Route path="contact" element={<Contact/>} />

          {/* Redirección por defecto */}
          <Route path="/*" element={<Navigate to="/public/home" />} />
        </Routes>
      </main>

      <Footer />
    </div>
  )
}
